'use strict';

var styled = require('styled-components');
var palette = require('../../theme/palette.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

const stylesByVariant = {
    'heading-1': styled.css `
    font-weight: ${({ theme }) => theme.designTokens.heading1FontWeight};
    font-size: ${({ theme }) => theme.designTokens.heading1FontSize};
    line-height: ${({ theme }) => theme.designTokens.heading1LineHeight};
  `,
    'heading-2': styled.css `
    font-weight: ${({ theme }) => theme.designTokens.heading2FontWeight};
    font-size: ${({ theme }) => theme.designTokens.heading2FontSize};
    line-height: ${({ theme }) => theme.designTokens.heading2LineHeight};
  `,
    'heading-3': styled.css `
    font-weight: ${({ theme }) => theme.designTokens.heading3FontWeight};
    font-size: ${({ theme }) => theme.designTokens.heading3FontSize};
    line-height: ${({ theme }) => theme.designTokens.heading3LineHeight};
  `,
    'heading-4': styled.css `
    font-weight: ${({ theme }) => theme.designTokens.heading4FontWeight};
    font-size: ${({ theme }) => theme.designTokens.heading4FontSize};
    line-height: ${({ theme }) => theme.designTokens.heading4LineHeight};
  `,
    'heading-4-light': styled.css `
    font-weight: ${({ theme }) => theme.designTokens.heading4LightFontWeight};
    font-size: ${({ theme }) => theme.designTokens.heading4LightFontSize};
    line-height: ${({ theme }) => theme.designTokens.heading4LightLineHeight};
  `,
    'heading-5': styled.css `
    font-weight: ${({ theme }) => theme.designTokens.heading5FontWeight};
    font-size: ${({ theme }) => theme.designTokens.heading5FontSize};
    line-height: ${({ theme }) => theme.designTokens.heading5LineHeight};
  `,
    'heading-5-light': styled.css `
    font-weight: ${({ theme }) => theme.designTokens.heading5LightFontWeight};
    font-size: ${({ theme }) => theme.designTokens.heading5LightFontSize};
    line-height: ${({ theme }) => theme.designTokens.heading5LightLineHeight};
  `,
    subtitle: styled.css `
    font-weight: ${({ theme }) => theme.designTokens.headingSubtitleFontWeight};
    font-size: ${({ theme }) => theme.designTokens.headingSubtitleFontSize};
    line-height: ${({ theme }) => theme.designTokens.headingSubtitleLineHeight};
  `,
    'subtitle-light': styled.css `
    font-weight: ${({ theme }) => theme.designTokens.headingSubtitleLightFontWeight};
    font-size: ${({ theme }) => theme.designTokens.headingSubtitleLightFontSize};
    line-height: ${({ theme }) => theme.designTokens.headingSubtitleLightLineHeight};
  `,
};
const propsToOmitInDOM = new Set([
    'variant',
    'textAlign',
    'textDecoration',
    'textOverflow',
    'textTransform',
]);
const Div = styled__default.default.div.withConfig({
    shouldForwardProp: prop => !propsToOmitInDOM.has(prop),
}) `
  margin: 0;
  overflow: ${({ overflow }) => overflow};
  font: inherit;
  display: ${({ display }) => display};
  box-sizing: border-box;
  font-family: ${({ theme }) => theme.designTokens.headingFontFamily};
  color: ${({ theme, color }) => (color ? palette.textColors[color] : theme.designTokens.headingTextColor)};
  letter-spacing: ${({ theme }) => theme.designTokens.headingLetterSpacing};
  text-align: ${({ textAlign: align }) => align};
  text-decoration: ${({ textDecoration: decoration }) => decoration};
  text-overflow: ${({ textOverflow }) => textOverflow};
  ${({ textOverflow }) => (textOverflow === 'clip' || textOverflow === 'ellipsis') &&
    `
      white-space: nowrap;
      overflow-x: hidden;
    `}
  text-rendering: optimizeLegibility;
  text-transform: ${({ textTransform }) => textTransform};
  ${({ variant }) => stylesByVariant[variant]}
`;
const Styled = {
    Div,
};

exports.Styled = Styled;
//# sourceMappingURL=styles.js.map
